/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {OptimizationRun} from '../bioplanModels';
// @ts-ignore
import type {OptimizationRunMessage} from '../bioplanModels';
// @ts-ignore
import type {WriteOptimizationRun} from '../bioplanModels';
/**
 * OptimizationOptimizeApi - axios parameter creator
 * @export
 */
export const OptimizationOptimizeApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get the input data for a stocker run
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationRunsDataPlanIdGet: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('optimizationRunsDataPlanIdGet', 'planId', planId);
      const localVarPath = `/optimizationRuns/data/{planId}`.replace(
        `{${'planId'}}`,
        encodeURIComponent(String(planId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all optimization runs
     * @param {string} [planId]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationRunsGet: async (
      planId?: string,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/optimizationRuns/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new optimization run for a plan
     * @param {WriteOptimizationRun} writeOptimizationRun
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationRunsPost: async (
      writeOptimizationRun: WriteOptimizationRun,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'writeOptimizationRun' is not null or undefined
      assertParamExists('optimizationRunsPost', 'writeOptimizationRun', writeOptimizationRun);
      const localVarPath = `/optimizationRuns/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writeOptimizationRun, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationRunsRunIdCancelPut: async (
      runId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'runId' is not null or undefined
      assertParamExists('optimizationRunsRunIdCancelPut', 'runId', runId);
      const localVarPath = `/optimizationRuns/{runId}/cancel`.replace(
        `{${'runId'}}`,
        encodeURIComponent(String(runId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationRunsRunIdGet: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'runId' is not null or undefined
      assertParamExists('optimizationRunsRunIdGet', 'runId', runId);
      const localVarPath = `/optimizationRuns/{runId}`.replace(`{${'runId'}}`, encodeURIComponent(String(runId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationRunsRunIdStatusGet: async (
      runId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'runId' is not null or undefined
      assertParamExists('optimizationRunsRunIdStatusGet', 'runId', runId);
      const localVarPath = `/optimizationRuns/{runId}/status`.replace(
        `{${'runId'}}`,
        encodeURIComponent(String(runId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OptimizationOptimizeApi - functional programming interface
 * @export
 */
export const OptimizationOptimizeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OptimizationOptimizeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get the input data for a stocker run
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizationRunsDataPlanIdGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizationRunsDataPlanIdGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OptimizationOptimizeApi.optimizationRunsDataPlanIdGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all optimization runs
     * @param {string} [planId]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizationRunsGet(
      planId?: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptimizationRun>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizationRunsGet(planId, limit, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OptimizationOptimizeApi.optimizationRunsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new optimization run for a plan
     * @param {WriteOptimizationRun} writeOptimizationRun
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizationRunsPost(
      writeOptimizationRun: WriteOptimizationRun,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OptimizationRun>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizationRunsPost(writeOptimizationRun, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OptimizationOptimizeApi.optimizationRunsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizationRunsRunIdCancelPut(
      runId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizationRunsRunIdCancelPut(runId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OptimizationOptimizeApi.optimizationRunsRunIdCancelPut']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizationRunsRunIdGet(
      runId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OptimizationRun>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizationRunsRunIdGet(runId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OptimizationOptimizeApi.optimizationRunsRunIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizationRunsRunIdStatusGet(
      runId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptimizationRunMessage>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizationRunsRunIdStatusGet(runId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OptimizationOptimizeApi.optimizationRunsRunIdStatusGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * OptimizationOptimizeApi - factory interface
 * @export
 */
export const OptimizationOptimizeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = OptimizationOptimizeApiFp(configuration);
  return {
    /**
     *
     * @summary Get the input data for a stocker run
     * @param {OptimizationOptimizeApiOptimizationRunsDataPlanIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationRunsDataPlanIdGet(
      requestParameters: OptimizationOptimizeApiOptimizationRunsDataPlanIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .optimizationRunsDataPlanIdGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all optimization runs
     * @param {OptimizationOptimizeApiOptimizationRunsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationRunsGet(
      requestParameters: OptimizationOptimizeApiOptimizationRunsGetRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<OptimizationRun>> {
      return localVarFp
        .optimizationRunsGet(requestParameters.planId, requestParameters.limit, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new optimization run for a plan
     * @param {OptimizationOptimizeApiOptimizationRunsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationRunsPost(
      requestParameters: OptimizationOptimizeApiOptimizationRunsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OptimizationRun> {
      return localVarFp
        .optimizationRunsPost(requestParameters.writeOptimizationRun, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {OptimizationOptimizeApiOptimizationRunsRunIdCancelPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationRunsRunIdCancelPut(
      requestParameters: OptimizationOptimizeApiOptimizationRunsRunIdCancelPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .optimizationRunsRunIdCancelPut(requestParameters.runId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {OptimizationOptimizeApiOptimizationRunsRunIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationRunsRunIdGet(
      requestParameters: OptimizationOptimizeApiOptimizationRunsRunIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OptimizationRun> {
      return localVarFp
        .optimizationRunsRunIdGet(requestParameters.runId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {OptimizationOptimizeApiOptimizationRunsRunIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationRunsRunIdStatusGet(
      requestParameters: OptimizationOptimizeApiOptimizationRunsRunIdStatusGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<OptimizationRunMessage>> {
      return localVarFp
        .optimizationRunsRunIdStatusGet(requestParameters.runId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for optimizationRunsDataPlanIdGet operation in OptimizationOptimizeApi.
 * @export
 * @interface OptimizationOptimizeApiOptimizationRunsDataPlanIdGetRequest
 */
export interface OptimizationOptimizeApiOptimizationRunsDataPlanIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof OptimizationOptimizeApiOptimizationRunsDataPlanIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for optimizationRunsGet operation in OptimizationOptimizeApi.
 * @export
 * @interface OptimizationOptimizeApiOptimizationRunsGetRequest
 */
export interface OptimizationOptimizeApiOptimizationRunsGetRequest {
  /**
   *
   * @type {string}
   * @memberof OptimizationOptimizeApiOptimizationRunsGet
   */
  readonly planId?: string;

  /**
   *
   * @type {number}
   * @memberof OptimizationOptimizeApiOptimizationRunsGet
   */
  readonly limit?: number;
}

/**
 * Request parameters for optimizationRunsPost operation in OptimizationOptimizeApi.
 * @export
 * @interface OptimizationOptimizeApiOptimizationRunsPostRequest
 */
export interface OptimizationOptimizeApiOptimizationRunsPostRequest {
  /**
   *
   * @type {WriteOptimizationRun}
   * @memberof OptimizationOptimizeApiOptimizationRunsPost
   */
  readonly writeOptimizationRun: WriteOptimizationRun;
}

/**
 * Request parameters for optimizationRunsRunIdCancelPut operation in OptimizationOptimizeApi.
 * @export
 * @interface OptimizationOptimizeApiOptimizationRunsRunIdCancelPutRequest
 */
export interface OptimizationOptimizeApiOptimizationRunsRunIdCancelPutRequest {
  /**
   *
   * @type {string}
   * @memberof OptimizationOptimizeApiOptimizationRunsRunIdCancelPut
   */
  readonly runId: string;
}

/**
 * Request parameters for optimizationRunsRunIdGet operation in OptimizationOptimizeApi.
 * @export
 * @interface OptimizationOptimizeApiOptimizationRunsRunIdGetRequest
 */
export interface OptimizationOptimizeApiOptimizationRunsRunIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof OptimizationOptimizeApiOptimizationRunsRunIdGet
   */
  readonly runId: string;
}

/**
 * Request parameters for optimizationRunsRunIdStatusGet operation in OptimizationOptimizeApi.
 * @export
 * @interface OptimizationOptimizeApiOptimizationRunsRunIdStatusGetRequest
 */
export interface OptimizationOptimizeApiOptimizationRunsRunIdStatusGetRequest {
  /**
   *
   * @type {string}
   * @memberof OptimizationOptimizeApiOptimizationRunsRunIdStatusGet
   */
  readonly runId: string;
}

/**
 * OptimizationOptimizeApi - object-oriented interface
 * @export
 * @class OptimizationOptimizeApi
 * @extends {BaseAPI}
 */
export class OptimizationOptimizeApi extends BaseAPI {
  /**
   *
   * @summary Get the input data for a stocker run
   * @param {OptimizationOptimizeApiOptimizationRunsDataPlanIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizationOptimizeApi
   */
  public optimizationRunsDataPlanIdGet(
    requestParameters: OptimizationOptimizeApiOptimizationRunsDataPlanIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OptimizationOptimizeApiFp(this.configuration)
      .optimizationRunsDataPlanIdGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all optimization runs
   * @param {OptimizationOptimizeApiOptimizationRunsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizationOptimizeApi
   */
  public optimizationRunsGet(
    requestParameters: OptimizationOptimizeApiOptimizationRunsGetRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return OptimizationOptimizeApiFp(this.configuration)
      .optimizationRunsGet(requestParameters.planId, requestParameters.limit, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new optimization run for a plan
   * @param {OptimizationOptimizeApiOptimizationRunsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizationOptimizeApi
   */
  public optimizationRunsPost(
    requestParameters: OptimizationOptimizeApiOptimizationRunsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OptimizationOptimizeApiFp(this.configuration)
      .optimizationRunsPost(requestParameters.writeOptimizationRun, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {OptimizationOptimizeApiOptimizationRunsRunIdCancelPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizationOptimizeApi
   */
  public optimizationRunsRunIdCancelPut(
    requestParameters: OptimizationOptimizeApiOptimizationRunsRunIdCancelPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OptimizationOptimizeApiFp(this.configuration)
      .optimizationRunsRunIdCancelPut(requestParameters.runId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {OptimizationOptimizeApiOptimizationRunsRunIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizationOptimizeApi
   */
  public optimizationRunsRunIdGet(
    requestParameters: OptimizationOptimizeApiOptimizationRunsRunIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OptimizationOptimizeApiFp(this.configuration)
      .optimizationRunsRunIdGet(requestParameters.runId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {OptimizationOptimizeApiOptimizationRunsRunIdStatusGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizationOptimizeApi
   */
  public optimizationRunsRunIdStatusGet(
    requestParameters: OptimizationOptimizeApiOptimizationRunsRunIdStatusGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OptimizationOptimizeApiFp(this.configuration)
      .optimizationRunsRunIdStatusGet(requestParameters.runId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
